import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider } from 'styled-components';
import MainRoutes from './routes';
import { queryClient } from './services/queryClient';
import { GlobalStyles } from './styles/global';
import { defaultTheme } from './styles/themes/default';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';

if (import.meta.env.MODE === 'production') {
  disableReactDevTools();
}

document.addEventListener(
  'wheel',
  () => {
    if ((document.activeElement as HTMLInputElement).type === 'number') {
      (document.activeElement as HTMLInputElement).blur();
    }
  },
  { passive: true }
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <ThemeProvider theme={defaultTheme}>
    <GlobalStyles />
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <MainRoutes />
      </QueryClientProvider>
    </React.StrictMode>
  </ThemeProvider>
);
